export default __webpack_public_path__ + "static/media/pl.ff5284c3.svg";